var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDb2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_9_44)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12H24V0H0V12Z",
  fill: "#1B1918"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2271 3.4219H16.7758L16.9267 3.00039H19.2271V3.4219Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6922 3.0002L14.9681 3L15.1173 3.42269C15.1182 3.4221 12.6929 3.42328 12.6929 3.42269C12.6929 3.4221 12.6914 3.00039 12.6922 3.00039V3.0002Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8844 3.00039C11.2596 3.0364 11.5857 3.16982 11.8634 3.42288C11.8634 3.42288 7.73795 3.42327 7.73795 3.42288C7.73795 3.42229 7.73795 3.00039 7.73795 3.00039H10.8844Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.50021 3.42195H7.36639V3.00024H4.50021V3.42195Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2271 4.21359H16.4947C16.4947 4.21359 16.6438 3.79405 16.6428 3.79386H19.2271V4.21359Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3987 4.21399H12.6919V3.79386H15.2504L15.3987 4.21399Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1848 3.79347C12.2392 3.932 12.3035 4.05047 12.3035 4.21321H7.73873V3.79347H12.1848Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.50034 4.21321H7.36651V3.79347H4.50034V4.21321Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2152 5.00651L16.3653 4.585L18.4168 4.58559V5.00552L16.2152 5.00651Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5305 4.585L15.6798 5.0067H13.4991V4.585H15.5305Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3396 4.585C12.3396 4.72943 12.3215 4.88017 12.2793 5.0067H11.0294V4.585H12.3396Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.29924 5.00648H6.53112V4.58693H5.29924V5.00648Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.56788 5.00651H9.79759V4.585H8.56788V5.00651Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7105 5.46175C14.7105 5.46175 14.7107 5.78094 14.7105 5.78153H13.4991V5.36198H15.8076L15.9511 5.75319C15.9516 5.75339 16.0891 5.361 16.0895 5.36179H18.4162V5.78153H17.2105C17.2105 5.78094 17.21 5.46195 17.21 5.46195L17.0983 5.78153L14.8217 5.78094L14.7105 5.46175Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.56788 5.36179H12.0982C12.0209 5.50229 11.8808 5.6731 11.7479 5.78152C11.7479 5.78152 8.56788 5.78212 8.56788 5.78152C8.56788 5.78093 8.56788 5.36257 8.56788 5.36179Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.29924 5.78152H6.53112V5.36179H5.29924V5.78152Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 6.57208H18.4162V6.15254H17.2105V6.57208Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7105 6.15254H13.4991V6.57208C13.4983 6.57188 14.7107 6.57228 14.7107 6.57208C14.7107 6.57188 14.7121 6.15254 14.7105 6.15254Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9671 6.15254C16.9616 6.15195 16.8259 6.57188 16.8202 6.57208L15.103 6.57287C15.1016 6.57228 14.9521 6.15195 14.9519 6.15254H16.9671Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.56768 6.15254H11.742C11.8868 6.27317 12.0177 6.42174 12.1203 6.57228C12.1262 6.57208 8.56788 6.57247 8.56788 6.57228C8.56788 6.57208 8.56768 6.15313 8.56768 6.15254Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.53094 6.57228V6.15254H5.30122C5.30122 6.15254 5.30162 6.57208 5.30122 6.57208C5.30103 6.57208 6.53035 6.57228 6.53094 6.57228Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 7.36342H18.416V6.94368H17.2105V7.36342Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4989 7.36322H14.7105V6.94368H13.4989V7.36322Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5383 7.36538C16.5387 7.36342 16.687 6.94328 16.6892 6.94368H15.2295C15.2269 6.94348 15.3792 7.36342 15.3792 7.36342C15.3792 7.36342 16.5379 7.36716 16.5383 7.36538Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.56787 7.36322C8.56787 7.36499 8.56767 6.94368 8.56787 6.94368H9.81593C9.81593 6.94368 9.81691 7.36342 9.81593 7.36342C9.81474 7.36342 8.56787 7.36302 8.56787 7.36322Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2954 6.94368C12.3558 7.07001 12.3619 7.22075 12.374 7.36519H11.0515V6.94368H12.2954Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.30122 7.36322H6.53094V6.94368H5.30122V7.36322Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 8.13866H19.2271V7.71892H17.2105V8.13866Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6919 8.13866H14.7105V7.71892H12.6919V8.13866Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2671 8.13866H15.6514L15.5037 7.71892H16.4095L16.2671 8.13866Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.50015 7.71892V8.13846H7.36435C7.36553 8.13925 7.36297 7.71911 7.36435 7.71911C7.36553 7.71911 4.49699 7.71892 4.50015 7.71892Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3215 7.71892C12.2913 7.85745 12.2637 8.0261 12.1623 8.13866L12.1244 8.13846H7.73853V7.71892H12.3215Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9879 8.93078H15.9313L15.7873 8.51006H16.1357L15.9879 8.93078Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2105 8.93176H19.2271V8.51006H17.2105V8.93176Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.73795 8.93077V8.51083C7.73795 8.51083 11.8759 8.51142 11.8877 8.51142C11.6098 8.77629 11.2287 8.92585 10.8182 8.93175L7.73854 8.93096L7.73795 8.93077Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6919 8.93176H14.7105V8.51006H12.6919V8.93176Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.36435 8.51201C7.36435 8.51201 7.36297 8.93077 7.36435 8.93077C7.36554 8.93077 4.50114 8.93254 4.50015 8.93155C4.49956 8.93077 4.50094 8.51083 4.50015 8.51083C4.49956 8.51083 7.36297 8.51339 7.36435 8.51201Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9241 8.07958C20.0014 8.07958 20.077 8.09926 20.1509 8.13921C20.2245 8.17857 20.2821 8.23544 20.3231 8.30923C20.3644 8.38302 20.3849 8.45997 20.3849 8.54006C20.3849 8.61916 20.3648 8.69571 20.3241 8.76872C20.2835 8.84192 20.2269 8.89879 20.1535 8.93913C20.0803 8.97967 20.0038 8.99994 19.9241 8.99994C19.8442 8.99994 19.7676 8.97967 19.6945 8.93913C19.6211 8.89879 19.5643 8.84192 19.5234 8.76872C19.4828 8.69571 19.4623 8.61916 19.4623 8.54006C19.4623 8.45997 19.483 8.38302 19.5244 8.30923C19.5659 8.23544 19.6235 8.17857 19.697 8.13921C19.771 8.09926 19.8466 8.07958 19.9241 8.07958ZM19.9241 8.15574C19.8592 8.15574 19.7961 8.17246 19.7347 8.20552C19.6734 8.23858 19.6254 8.28601 19.5907 8.3476C19.556 8.4092 19.5388 8.47335 19.5388 8.54006C19.5388 8.60637 19.5558 8.66974 19.5899 8.73054C19.6238 8.79135 19.6714 8.83877 19.7325 8.87282C19.7937 8.90666 19.8576 8.92378 19.9241 8.92378C19.9904 8.92378 20.0543 8.90666 20.1154 8.87282C20.1766 8.83877 20.2241 8.79135 20.2578 8.73054C20.2918 8.66974 20.3085 8.60637 20.3085 8.54006C20.3085 8.47335 20.2912 8.4092 20.2569 8.3476C20.2223 8.28601 20.1744 8.23858 20.1129 8.20552C20.0513 8.17246 19.9884 8.15574 19.9241 8.15574ZM19.7215 8.79391V8.29939H19.8921C19.9505 8.29939 19.9927 8.30392 20.0188 8.31317C20.045 8.32222 20.0657 8.33816 20.0813 8.36098C20.0969 8.38361 20.1046 8.40782 20.1046 8.4334C20.1046 8.46941 20.0915 8.50109 20.0655 8.52766C20.0397 8.55462 20.0051 8.56957 19.9623 8.57292C19.9797 8.5802 19.9939 8.58886 20.0044 8.59909C20.0245 8.61838 20.0489 8.65104 20.0779 8.69709L20.1383 8.79391H20.0411L19.9969 8.71598C19.9623 8.65458 19.9341 8.61621 19.9128 8.60067C19.8982 8.58945 19.8769 8.58394 19.8487 8.58414H19.8016V8.79391H19.7215ZM19.8016 8.51546H19.8988C19.9454 8.51546 19.9771 8.50857 19.9939 8.4948C20.0109 8.48102 20.0194 8.46272 20.0194 8.44029C20.0194 8.42573 20.0152 8.41254 20.0071 8.40113C19.999 8.38952 19.9878 8.38086 19.9734 8.37535C19.9588 8.36964 19.932 8.36689 19.8927 8.36689H19.8016V8.51546Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 24H24V12H0V24Z",
  fill: "#09AF05"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.97344 20.5593V15.1978H7.45753C9.3508 15.1978 10.2987 16.0683 10.2987 17.8115C10.2987 18.6384 10.0352 19.3035 9.50946 19.8062C8.98371 20.3077 8.2801 20.5593 7.39733 20.5593H5.97344ZM6.60294 15.7658V19.9914H7.40501C8.10991 19.9914 8.65743 19.8024 9.05014 19.426C9.44303 19.0494 9.63865 18.5159 9.63865 17.8255C9.63865 16.4524 8.90685 15.7658 7.44216 15.7658H6.60294ZM11.3555 20.5593V15.1978H12.8843C13.3487 15.1978 13.7184 15.3114 13.9896 15.5374C14.262 15.7645 14.3989 16.0606 14.3989 16.4242C14.3989 16.728 14.3158 16.9922 14.1508 17.2167C13.9857 17.4414 13.7593 17.601 13.4689 17.6954V17.7107C13.8309 17.7529 14.1213 17.8894 14.3389 18.1191C14.5563 18.35 14.665 18.6499 14.665 19.0189C14.665 19.4769 14.4999 19.8484 14.17 20.133C13.8399 20.4174 13.4241 20.5593 12.9214 20.5593H11.3555ZM11.9848 15.7658V17.4977H12.6297C12.9737 17.4977 13.2449 17.4146 13.4433 17.2487C13.6404 17.0827 13.7388 16.8492 13.7388 16.5467C13.7388 16.0261 13.3959 15.7658 12.7077 15.7658H11.9848ZM11.9848 18.0616V19.9914H12.8394C13.2093 19.9914 13.4958 19.9032 13.6991 19.7298C13.9039 19.5549 14.0049 19.3148 14.0049 19.0112C14.0049 18.3781 13.5725 18.0616 12.7077 18.0616H11.9848ZM18.6488 20.5593H15.4096V20.0129L16.9768 18.4471C17.3759 18.0477 17.6625 17.7158 17.8326 17.4504C18.0039 17.1849 18.0897 16.9016 18.0897 16.5991C18.0897 16.2903 18.0014 16.0517 17.8237 15.8819C17.6458 15.7121 17.3938 15.6279 17.0663 15.6279C16.5864 15.6279 16.1273 15.832 15.6872 16.2404V15.5973C16.1068 15.2705 16.5954 15.1073 17.1532 15.1073C17.633 15.1073 18.009 15.2375 18.2841 15.4965C18.5591 15.7555 18.6973 16.104 18.6973 16.5403C18.6973 16.8837 18.6014 17.2193 18.412 17.5473C18.2215 17.8754 17.8811 18.2825 17.3887 18.7686L16.1478 19.9914V20.0054H18.6488V20.5593Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.3164 20.1462C19.3881 20.1462 19.4582 20.1646 19.5266 20.2015C19.5951 20.2382 19.6485 20.2908 19.6866 20.3592C19.7246 20.4277 19.7438 20.4993 19.7438 20.5734C19.7438 20.6469 19.725 20.7178 19.6873 20.7855C19.6498 20.8534 19.5971 20.9062 19.5292 20.9436C19.4613 20.9814 19.3903 21 19.3164 21C19.2422 21 19.1712 20.9814 19.1032 20.9436C19.0353 20.9062 18.9824 20.8534 18.9447 20.7855C18.907 20.7178 18.888 20.6469 18.888 20.5734C18.888 20.4993 18.9072 20.4277 18.9454 20.3592C18.984 20.2908 19.0375 20.2382 19.1057 20.2015C19.1742 20.1646 19.2443 20.1462 19.3164 20.1462ZM19.3164 20.2168C19.2562 20.2168 19.1974 20.2324 19.1405 20.263C19.0836 20.2937 19.0391 20.3377 19.0071 20.395C18.9749 20.4522 18.9588 20.5115 18.9588 20.5734C18.9588 20.6349 18.9747 20.6939 19.0062 20.7503C19.0378 20.8065 19.0819 20.8507 19.1387 20.8821C19.1954 20.9135 19.2545 20.9294 19.3164 20.9294C19.3778 20.9294 19.4371 20.9135 19.4939 20.8821C19.5504 20.8507 19.5947 20.8065 19.626 20.7503C19.6573 20.6939 19.673 20.6349 19.673 20.5734C19.673 20.5115 19.6569 20.4522 19.6251 20.395C19.5931 20.3377 19.5486 20.2937 19.4915 20.263C19.4344 20.2324 19.376 20.2168 19.3164 20.2168ZM19.1284 20.8089V20.3501H19.2867C19.3409 20.3501 19.38 20.3543 19.4042 20.3629C19.4285 20.3713 19.4478 20.3861 19.4622 20.4072C19.4765 20.4282 19.4838 20.4507 19.4838 20.4744C19.4838 20.5078 19.4717 20.5372 19.4476 20.5619C19.4236 20.5869 19.3916 20.6008 19.3517 20.6039C19.368 20.6106 19.3811 20.6186 19.3908 20.6281C19.4093 20.646 19.432 20.6765 19.4589 20.719L19.5151 20.8089H19.4249L19.3839 20.7368C19.3517 20.6796 19.3257 20.644 19.3059 20.6298C19.2924 20.6192 19.2726 20.6141 19.2465 20.6143H19.2027V20.8089H19.1284ZM19.2027 20.5506H19.2929C19.3361 20.5506 19.3654 20.5442 19.3811 20.5314C19.3969 20.5186 19.4047 20.5016 19.4047 20.4808C19.4047 20.4673 19.4009 20.4551 19.3934 20.4445C19.3857 20.4337 19.3753 20.4259 19.3619 20.4206C19.3484 20.4155 19.3237 20.4127 19.2873 20.4127H19.2027V20.5506Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_9_44"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 1.5,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDb2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/db2.78c831602c24d7e3c78ffb41d4e3cb07.svg";